/// <reference path="../typings/Common.d.ts" />

import * as React from "react";
import * as Dropzone from 'react-dropzone';

import { IApplicationStoreState, applicationStore } from '../stores/ApplicationStore'
import { TransactionType } from '../utils/Common'
import { ActionCreator } from '../actions/ActionCreator'

export interface IConfigurationNavigationProps {
    activeData?: IConfigurationData,
    onItemClick: (data: IConfigurationData) => void
}

export default class ConfigurationNavigation extends React.Component<IConfigurationNavigationProps, IApplicationStoreState> {

    constructor() {
        super();

        this.state = applicationStore.getState();

        this.onChange = this.onChange.bind(this);
        this.downloadConfigurationFiles = this.downloadConfigurationFiles.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    componentDidMount() {
        applicationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        applicationStore.removeChangeListener(this.onChange);
    }

    onChange() {
        this.setState(applicationStore.getState());
    }

    handleItemClick(data: IConfigurationData) {
        this.props.onItemClick(data);
    }

    downloadConfigurationFiles(e: any) {
        e.preventDefault();

        ActionCreator.downloadConfigurationFiles(this.state.merchantId, this.state.terminalId);
    }

    onDrop(acceptedFiles: Dropzone.ImageFile[]) {
        ActionCreator.uploadConfigurationFiles(this.state.merchantId, this.state.terminalId, acceptedFiles[0]);
    }

    render() {
        var data: any = {};
        var result: Object[] = [];
        for (var i = 0; i < TransactionType.FINAL_ENUM; ++i) {
            data[TransactionType[i]] = [];
            data[TransactionType[i]] = this.state.configurationData
                .filter(function (d) { return d.Type == TransactionType[i] })
                .sort(function (l, r) {
                    return l.Priority < r.Priority ? 1 : l.Priority > r.Priority ? -1 : 0;
                });

            var values: Object[] = [];
            data[TransactionType[i]].map(function (d: IConfigurationData) {
                var liClassName = this.props.activeData && this.props.activeData.Guid === d.Guid ? "active" : "";

                values.push(
                    <li key={`${d.Type}-${d.Guid}`}
                        className={liClassName}>
                        <a onClick={this.handleItemClick.bind(this, d)}>
                            {d.Priority + ' - ' + d.Name}
                        </a>
                    </li>
                );
            }, this);

            var href = `collapse-${i}`;
            var panelClass = "panel-collapse collapse " + (this.props.activeData && this.props.activeData.Type === TransactionType[i] ? "in" : "");
            var titleClass = (this.props.activeData && this.props.activeData.Type === TransactionType[i] ? "" : "collapsed");
            result.push(
                <div className="panel panel-default"
                    key={TransactionType[i]}>
                    <div className="panel-heading">
                        <h4 className="panel-title">
                            <a href={'#' + href}
                                data-toggle="collapse"
                                data-parent="#accordion"
                                className={titleClass}>
                                {TransactionType[i] + ' (' + data[TransactionType[i]].length + ')'}
                            </a>
                        </h4>
                    </div>
                    <div id={href}
                        className={panelClass}>
                        <div className="panel-body">
                            <ul className="nav nav-pills nav-stacked">
                                {values}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }

        var downloadConfigurationBtnStyle = {
            margin: '5px'
        }

        var dropzoneStyle = {
            width: "300px",
            height: "25px",
            "border-width": "2px",
            "border-color": "rgb(102, 102, 102)",
            "border-style": "dashed",
            "border-radius": "5px",
            "text-align": "center",
            "margin": "5px"
        };

        return (
            <div>
                {
                    this.state.isSelected ?
                        (
                            <div>
                                <div className="row center-block">
                                    <button type="button"
                                        className="col-xs-12 btn btn-primary"
                                        style={downloadConfigurationBtnStyle}
                                        onClick={this.downloadConfigurationFiles}>
                                        Download Configuration
                                </button>
                                </div>
                                <div className="row center-block dropzone">
                                    <Dropzone onDrop={this.onDrop}
                                        multiple={false}
                                        disablePreview={true}
                                        style={dropzoneStyle}>
                                        <p>Drop configuration here to upload.</p>
                                    </Dropzone>
                                </div>
                            </div>
                        )
                        : ""
                }
                <div className="panel-group" id="accordion">
                    {result}
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/ConfigurationNavigation.tsx